import { ModelTarget } from '@app/api/migrations/migration';
import { MessageAlert } from '@app/components/AppAlert';
import { migrateParrainages } from '@app/api/migrations/migration';
import { useState } from 'react';
import AppDropZone from '@app/components/AppDropZone';
import { Button, Tabs } from '@mui/joy';
import { TabPanel } from '@mui/joy';
import { Tab } from '@mui/joy';
import { TabList } from '@mui/joy';
import { AppIcon } from '@app/components/AppIcon';
import ImportParrainagesForm from './importparrainagesForm';

const ImportParrainages = () => {
    const [loadingImport, setLoadingImport] = useState(false);
    const [messageAlert, setMessageAlert] = useState<MessageAlert | null>(null);
    const [file, setFile] = useState<File | null>(null);

    const handleSubmitFileXML = (file: File | null) => {
        if (!file) return;
        let modelTarget: ModelTarget;
        setLoadingImport(true);
        modelTarget = 'parrainage';
        migrateParrainages({
            file: file,
            onSuccess: () => {
                setMessageAlert({
                    title: 'Success',
                    text: 'XML Migrés',
                    color: 'success',
                });
                setLoadingImport(false);
            },
            onError: (err) => {
                setMessageAlert({ title: 'Error', text: err, color: 'danger' });
                setLoadingImport(false);
            },
        });
    };

    const handleSubmitForm = (data: any) => {
        console.log(data);
        migrateParrainages({
            data: data,
            onSuccess: () => {
                setMessageAlert({
                    title: 'Success',
                    text: 'XML Migrés',
                    color: 'success',
                });
                setLoadingImport(false);
            },
            onError: (err) => {
                setMessageAlert({ title: 'Error', text: err, color: 'danger' });
                setLoadingImport(false);
            },
        });
    };

    return (
        <div className="mx-24 ">
            <div className=" mb-4 mt-6 flex items-center gap-4">
                <AppIcon icon="ArrowUpTrayIcon" />
                <div className="text-xl font-bold">Importer des Parranages</div>
            </div>
            <Tabs
                aria-label="Vertical tabs"
                orientation="vertical"
                variant="outlined"
                className="rounded-md"
                sx={{
                    height: '80vh',
                    backgroundColor: (theme) =>
                        theme.palette.background.surface,
                }}
            >
                <TabList>
                    <Tab variant="plain" color="primary">
                        Import XML
                    </Tab>
                    <Tab variant="plain" color="primary">
                        Import Manuel
                    </Tab>
                </TabList>
                <TabPanel value={0}>
                    <div className="mt-8 flex flex-col items-center justify-center gap-4">
                        <AppDropZone
                            loading={loadingImport}
                            message={messageAlert}
                            acceptFile="application/xml"
                            file={file}
                            onFileUpload={(file) => setFile(file)}
                        />

                        {!loadingImport && !messageAlert && (
                            <Button
                                disabled={!file}
                                startDecorator={
                                    <AppIcon icon="CloudArrowUpIcon" />
                                }
                                onClick={() => handleSubmitFileXML(file)}
                            >
                                Importer
                            </Button>
                        )}
                        {messageAlert && (
                            <Button
                                variant="outlined"
                                color="success"
                                startDecorator={
                                    <AppIcon icon="PlusCircleIcon" />
                                }
                                onClick={() => {
                                    setFile(null);
                                    setMessageAlert(null);
                                }}
                            >
                                {' '}
                                Importer à nouveau{' '}
                            </Button>
                        )}
                    </div>
                </TabPanel>
                <TabPanel
                    value={1}
                    className="h-[calc(100vh-200px)] overflow-y-auto "
                >
                    <div className="mt-8 flex flex-col items-center justify-center gap-4">
                        <ImportParrainagesForm onSubmit={handleSubmitForm} />
                    </div>
                </TabPanel>
            </Tabs>
        </div>
    );
};

export default ImportParrainages;
